module.exports = __webpack_public_path__ + "static/media/SILKSERIF-REGULAR.1d43a3d2.woff";